import * as config from '@/config/config.json';
import * as calculatorConfig from '@/config/base-config.json';
import { generateSliderSteps } from '@/utils/generateSliderSteps';
import {
  BEFORE_FOUNDATION_STAGE,
  CAR_PARK_STAGE,
  CEILING_STAGE,
  FOUNDATION_STAGE,
  FRAMEWORK_STAGE,
  UTILITY_STAGE,
  WALL_STAGE,
  WINDOW_STAGE,
} from '../buc';
import { formatUnit } from '@/lib/utils';

export const CI_INVESTMENT_LABEL = {
  BuildingUnderConstruction: 'Building Under Construction',
  Stage: 'Stage',
  RentalYears: 'Rental Years',
  PurchasePrice: 'Purchase Price',
  OptionFee: 'Option Fee',
  BSD: 'BSD',
  BSDLongForm: "Buyer's Stamp Duty",
  LoanTenure: 'Loan Tenure (Years)',
  MortgageLoanInterestRate: 'Mortgage Loan Interest Rate',
  LoanToValue: 'Loan-to-Value',
  LoanAmount: 'Loan Amount',
  MonthlyInstalment: 'Monthly Instalment',
  UponTOP: 'Upon TOP',
  UponCSC: 'Upon CSC',
  TotalInstalment: 'Total Instalment',
  DuringConstruction: 'During Construction',
  Rental: 'Rental',
  RentalPerMonth: 'Rental Per Month',
  DifferenceInMonthlyInstalmentAndRental: 'Difference in Monthly Instalment & Rental',
  DifferenceInCash: 'Difference in Cash',
  MaintenanceFee: 'Maintenance Fee',
  Monthly: 'Monthly',
  TotalMaintenanceFee: 'Total Maintenance Fee',
  PropertyTax: 'Property Tax',
  Sale: 'Sale',
  SaleOfProperty: 'Sale of Property',
  OutstandingLoan: 'Outstanding Loan',
  AfterOutstandingLoan: 'After Outstanding Loan',
  Summary: 'Summary',
  TotalDownpayment: 'Total Downpayment',
  IncludingBSD: 'Including BSD',
  PossibleReturns: 'Possible Returns',
  PossibleReturnsAgainstTotalDownpayment: 'Possible Returns Against Total Downpayment',
  PossibleReturnsBreakdown: 'Possible Returns Breakdown',
};

export const InvestmentBUCStage = [
  BEFORE_FOUNDATION_STAGE,
  FOUNDATION_STAGE,
  FRAMEWORK_STAGE,
  WALL_STAGE,
  CEILING_STAGE,
  WINDOW_STAGE,
  UTILITY_STAGE,
  CAR_PARK_STAGE,
];

export const StageOptions = InvestmentBUCStage.map((stage) => {
  return {
    value: stage,
    label: stage,
  };
});

export const RentalYearOptions = Array.from({ length: 11 }, (_v, i) => i).map((y) => {
  return {
    value: y.toString(),
    label: `${formatUnit(y, 'Year', 'Years')}`,
  };
});

export const getColorClassName = (value: number) => {
  if (value === 0) {
    return;
  }

  if (value > 0) {
    return 'text-green-500';
  }

  return 'text-eraRed-500';
};

export const LOAN_TENURE = {
  LABEL_INPUTS: generateSliderSteps(0, config.max_loan_tenure_in_years.commercial_industrial, 10),
  MAX: config.max_loan_tenure_in_years.commercial_industrial,
  STEP: 1,
  DEFAULT: config.max_loan_tenure_in_years.commercial_industrial,
};

export const CI_MORTGAGE_INTEREST_RATE = {
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.mortgage_interest_rate.commercial_industrial.min,
    calculatorConfig.mortgage_interest_rate.commercial_industrial.max,
    1,
  ),
  DEFAULT: calculatorConfig.mortgage_interest_rate.commercial_industrial.default,
  MAX: calculatorConfig.mortgage_interest_rate.commercial_industrial.max,
  STEP: 0.01,
};

export const CI_LOAN_TO_VALUE = {
  LABEL_INPUTS: generateSliderSteps(0, config.max_ltv_in_percent.commercial_industrial, 15),
  MAX: config.max_ltv_in_percent.commercial_industrial,
  STEP: 1,
  DEFAULT: config.max_ltv_in_percent.commercial_industrial,
};
